import { useState } from 'react';
import axios from 'axios';
import DownloadButton from './DownloadButton';
import MarkdownPreview from './MarkdownPreview';

export default function ResumeForm() {
    const [resumeText, setResumeText] = useState('');
    const [jobDescription, setJobDescription] = useState('');
    const [generatedResume, setGeneratedResume] = useState('');
    const [filename, setFilename] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [showMarkdown, setShowMarkdown] = useState(false);

    const buttonStyle = {
        width: '200px',
        height: '60px'
    };

    const generateResume = async () => {
        setError(null);

        // Client-side validation
        if (!resumeText.trim()) {
            setError('Please paste your resume text before generating.');
            return;
        }

        if (!jobDescription.trim()) {
            setError('Please paste the job description before generating.');
            return;
        }

        setLoading(true);
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL || 'http://localhost:5001'}/api/resume/generate`, {
                resumeText,
                jobDescription,
            });
            setGeneratedResume(response.data.markdown);
            setFilename(response.data.filename);
        } catch (err) {
            // Check if the error response has a specific message
            if (err.response && err.response.data && err.response.data.message) {
                setError(err.response.data.message);
            } else {
                setError('Error generating resume. Please try again later.');
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <h2>Generate ATS-Friendly Resume</h2>
            <div style={{ marginBottom: '10px' }}>
                <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                    Resume Text
                </label>
            </div>
            <textarea
                value={resumeText}
                onChange={(e) => setResumeText(e.target.value)}
                placeholder="Paste your resume text here"
                rows="10"
                cols="50"
                style={{ width: '100%', marginBottom: '15px' }}
            />
            <div style={{ marginBottom: '10px' }}>
                <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                    Job Description
                </label>
            </div>
            <textarea
                value={jobDescription}
                onChange={(e) => setJobDescription(e.target.value)}
                placeholder="Paste the job description here"
                rows="5"
                cols="50"
                style={{ width: '100%', marginBottom: '15px' }}
            />
            <div style={{ display: 'flex', gap: '10px', alignItems: 'center', justifyContent: 'center' }}>
                <button onClick={generateResume} disabled={loading} style={buttonStyle}>
                    {loading ? 'Generating...' : 'Optimize My Resume'}
                </button>
                <button
                    disabled
                    style={{
                        ...buttonStyle,
                        backgroundColor: '#ccc',
                        color: '#333',
                        cursor: 'not-allowed',
                        whiteSpace: 'normal',
                        lineHeight: '1.2',
                    }}
                >
                    Check Gaps
                    <br />
                    (Coming Soon)
                </button>
            </div>

            {error && <p style={{ color: 'red' }}>{error}</p>}
              {generatedResume && (
                <div>
                    <MarkdownPreview markdown={generatedResume} />
                    <div>
                        <h3
                            onClick={() => setShowMarkdown(!showMarkdown)}
                            style={{
                                cursor: 'pointer',
                                userSelect: 'none',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px'
                            }}
                        >
                            <span>{showMarkdown ? '▼' : '▶'}</span>
                            Generated Resume (Markdown)
                        </h3>
                        {showMarkdown && (
                            <pre style={{
                                backgroundColor: '#f5f5f5',
                                padding: '10px',
                                borderRadius: '4px',
                                overflow: 'auto',
                                maxHeight: '400px'
                            }}>
                                {generatedResume}
                            </pre>
                        )}
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            gap: '10px',
                            justifyContent: 'center',
                            flexWrap: 'wrap'
                        }}
                    >
                        <DownloadButton filename={filename} />
                    </div>
                </div>
            )}
        </div>
    );
}

